
import {
    Lightbox,
    initTE,
} from "tw-elements";

initTE({ Lightbox });
